import api from "../api";

export interface ReferralSummaryItem {
  id: number;
  status: string;
  status_label: string;
  explanation: string;
  referrer_points: number;
  can_appeal: boolean;
}

export interface ReferralSummary {
  point_value_gbp: number;
  wallet_balance: number;
  available_points: number;
  pending_points: number;
  pending_amount_gbp: number;
  reversed_points: number;
  can_apply_to_booking: boolean;
  redemption_rate: number;
  terms: string;
  invited_count: number;
  joined_count: number;
  completed_count: number;
  referrals: ReferralSummaryItem[];
}

class ReferralService {
  async summary(): Promise<ReferralSummary> {
    const response = await api.get("/referrals");
    return response.data.data;
  }

  async appeal(referralId: number, reason: string): Promise<void> {
    await api.post(`/referrals/${referralId}/appeal`, { reason });
  }
}

export default new ReferralService();
